import { defineFetch } from 'resift';

export default defineFetch({
  displayName: 'Get Entity Types',
  share: {
    namespace: 'entity types',
    merge: (previous, next) => ({ ...previous, ...next }),
  },
  make: () => ({
    key: [],
    request: () => ({ http }) =>
      http({
        method: 'GET',
        route: `/entity-types`,
        query: { returnDisabledFields: true },
      }),
  }),
});
